define.alias("shared/components/shared/locale", "calendar/components/shared/locale");